/* eslint-disable @next/next/no-img-element */
import React from 'react';
import Link from 'next/link';
import { TeamDetailItemFragment } from '@amf/shared/types/graphql';
import Container from '@amf/shared/components/layout/Container';
import TeamDress from '@amf/shared/components/team/TeamDress';
import { useTranslate } from '@tolgee/react';
import classNames from 'classnames';
import useBackgroundColor, { Background } from '@amf/shared/hooks/useBackgroundColor';

interface TeamHeaderProps {
  team: TeamDetailItemFragment;
  prefixes: { club: string };
}

function TeamHeader({ team, prefixes }: TeamHeaderProps) {
  const { t } = useTranslate();
  const { color } = useBackgroundColor(team.dressColorPrimary);
  return (
    <div className='PersonHeader PersonHeader--bottomFit'>
      <Container className='PersonHeader__container'>
        <div className='PersonHeader__navigation'>
          <h1 className='PersonHeader__title'>{t('team.title')}</h1>
        </div>
        <div className='PersonHeader__card'>
          <div className='PersonHeader__photo'>
            {team.club.brandUrl && <img src={team.club.brandUrl} alt={team.club.name} />}
            {!team.club.brandUrl && <div>{team.name.substring(0, 1)}</div>}
            <TeamDress
              className={classNames('PersonHeader__dress', {
                'PersonHeader__dress--dark': color === Background.dark,
                'PersonHeader__dress--light': color === Background.light,
              })}
              dress={team}
              shorts
            />
          </div>
          <div className='PersonHeader__content'>
            <h2 className='PersonHeader__fullName'>{team.name}</h2>
            <div>
              <p className='PersonHeader__identifier'>{team.amfId}</p>
            </div>
            <ul>
              <li>
                <label>{t('team.info.type')}</label>
                <strong>{t(`league.type.${team.type}`)}</strong>
              </li>
              <li>
                <label>{t('team.info.club')}</label>
                <strong>
                  <Link key={team.id} href={`${prefixes.club}/${team.club.id}`}>
                    <a>{team.club.name}</a>
                  </Link>
                </strong>
              </li>
            </ul>
          </div>
          <div className='PersonHeader__crosses'>
            <div className='PersonHeader__cross' />
            <div className='PersonHeader__cross' />
            <div className='PersonHeader__cross' />
            <div className='PersonHeader__cross' />
            <div className='PersonHeader__cross' />
          </div>
        </div>
      </Container>
    </div>
  );
}

export default TeamHeader;
